import {getCheckAnnouncement} from '../../apis';
import {getAnnouncements} from '../../apis/getInbox';
import {GET_ANNOUNCEMENT, SET_HAVE_NEW_NOTIF} from '../reducers/inbox';

export const getAnnouncments = () => {
  return async (dispatch, getState) => {
    const res = await getAnnouncements();
    if (res.status) {
      dispatch({type: GET_ANNOUNCEMENT, payload: res.data});
      return res.data;
    }
  };
};

export function getAndSetCheckAnnouncement() {
  return async (dispatch, getState) => {
    const data = await getCheckAnnouncement();
    dispatch(setCheckAnnouncement(data));
    return data;
  };
}

export function setCheckAnnouncement(data) {
  return {
    type: SET_HAVE_NEW_NOTIF,
    payload: {data},
  };
}
